<template>
  <section>
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: "ProjectsView"
}
</script>

<style scoped lang="stylus">
</style>
